export class StorageKey {
    public static readonly appTheme:string = "SDF_THEME";
    public static readonly accessToken: string = "SDF_ACCESS_TOKEN";
    public static readonly refreshToken: string = "SDF_REFRESH_TOKEN";
    public static readonly userId:string = "SDF_USER_ID";
    public static readonly notification_token:string = "SDF_NOTIFICATION_TOKEN";
    public static readonly user_status:string = 'SDF_USER_STATUS';
    public static readonly btm_device:string = 'SDF_BTM_DEVICE';
    public static readonly apple_logged_in:string = 'APPLE_LOGGED_IN';
}